"use strict";

var __awaiter = this && this.__awaiter || function (r, c, n, a) {
  return new (n || (n = Promise))(function (e, t) {
    function s(e) {
      try {
        o(a.next(e));
      } catch (e) {
        t(e);
      }
    }

    function i(e) {
      try {
        o(a.throw(e));
      } catch (e) {
        t(e);
      }
    }

    function o(t) {
      t.done ? e(t.value) : new n(function (e) {
        e(t.value);
      }).then(s, i);
    }

    o((a = a.apply(r, c || [])).next());
  });
},
    __generator = this && this.__generator || function (s, i) {
  var o,
      r,
      c,
      e,
      n = {
    label: 0,
    sent: function sent() {
      if (1 & c[0]) throw c[1];
      return c[1];
    },
    trys: [],
    ops: []
  };
  return e = {
    next: t(0),
    throw: t(1),
    return: t(2)
  }, "function" == typeof Symbol && (e[Symbol.iterator] = function () {
    return this;
  }), e;

  function t(t) {
    return function (e) {
      return function (t) {
        if (o) throw new TypeError("Generator is already executing.");

        for (; n;) {
          try {
            if (o = 1, r && (c = 2 & t[0] ? r.return : t[0] ? r.throw || ((c = r.return) && c.call(r), 0) : r.next) && !(c = c.call(r, t[1])).done) return c;

            switch (r = 0, c && (t = [2 & t[0], c.value]), t[0]) {
              case 0:
              case 1:
                c = t;
                break;

              case 4:
                return n.label++, {
                  value: t[1],
                  done: !1
                };

              case 5:
                n.label++, r = t[1], t = [0];
                continue;

              case 7:
                t = n.ops.pop(), n.trys.pop();
                continue;

              default:
                if (!(c = 0 < (c = n.trys).length && c[c.length - 1]) && (6 === t[0] || 2 === t[0])) {
                  n = 0;
                  continue;
                }

                if (3 === t[0] && (!c || t[1] > c[0] && t[1] < c[3])) {
                  n.label = t[1];
                  break;
                }

                if (6 === t[0] && n.label < c[1]) {
                  n.label = c[1], c = t;
                  break;
                }

                if (c && n.label < c[2]) {
                  n.label = c[2], n.ops.push(t);
                  break;
                }

                c[2] && n.ops.pop(), n.trys.pop();
                continue;
            }

            t = i.call(s, n);
          } catch (e) {
            t = [6, e], r = 0;
          } finally {
            o = c = 0;
          }
        }

        if (5 & t[0]) throw t[1];
        return {
          value: t[0] ? t[1] : void 0,
          done: !0
        };
      }([t, e]);
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var pako_1 = require("pako"),
    rxjs_1 = require("rxjs"),
    DataBuilder_1 = require("../classes/DataBuilder"),
    TouchRecord_1 = require("../implementation/TouchRecord"),
    TouchRecorder_1 = require("../implementation/TouchRecorder"),
    CodeType_1 = require("../model/CodeType"),
    DecoderResponseError_1 = require("../model/DecoderResponseError"),
    DecoderResponseSuccess_1 = require("../model/DecoderResponseSuccess"),
    PrismaKeyDetection_1 = require("./PrismaKeyDetection"),
    Detection = function () {
  function e(e, t) {
    this.successSubject = new rxjs_1.Subject(), this.errorSubject = new rxjs_1.Subject(), this.twoFingerHoldingMode = !1, this.prismaKeyDetection = null, this.codeSetTypes = [], this.url = "/decode", this.touchRecorder = new TouchRecorder_1.TouchRecorder(), this.activeTouches = 0, this.successCallbackSent = !1, this.errorCallbackSent = !1, this.activeRequestCount = 0, this.successCallbackXhrNum = 0, this.xhrRequestNum = 0, this.lastRequestTime = 0, this.gzipUsed = !1, this.previousProgressTimeStamp = 0, this.customPayload = null, this.paused = !1, this.decodeRequestSent = !1, this.sdk = e, this.strings = t;
  }

  return e.prototype.init = function (e) {
    this.codeSetTypes = e.codeSetTypes, this.touchRecorder.setGapBridgingConfig(e.gapBridgingConfig), "native" === this.sdk.getAppType() && "pixels" === this.sdk.getCoordinatesUnit() && this.touchRecorder.setBridgeGapThresholdScalingFactor(e.devicePixelRatio), this.codeSetTypes.includes(CodeType_1.CodeType.DisplacementKey) && (this.prismaKeyDetection = new PrismaKeyDetection_1.PrismaKeyDetection());
  }, e.prototype.success = function (e) {
    this.paused || this.successSubject.next(e);
  }, e.prototype.error = function (e) {
    this.paused || this.errorSubject.next(e);
  }, e.prototype.setCustomPayload = function (e) {
    try {
      JSON.stringify(e);
    } catch (e) {
      return !1;
    }

    return this.customPayload = e, !0;
  }, e.prototype.reset = function () {
    this.touchRecorder.clear(), this.successCallbackSent = !1, this.decodeRequestSent = !1, this.errorCallbackSent = !1, this.sdk.getProgress().reset(), this.prismaKeyDetection && this.prismaKeyDetection.reset();
  }, e.prototype.processTouchStart = function (e) {
    0 === this.activeTouches && this.sdk.getInteraction().started();
    var t = e.changedTouches;
    this.activeTouches += t.length, this.sdk.getInteraction().changed(this.activeTouches);

    for (var s = 0, i = t; s < i.length; s++) {
      var o = i[s],
          r = [],
          c = o.identifier;
      r.push(new TouchRecord_1.TouchRecord("start", c, o.radiusX, o.pageX, o.pageY)), this.touchRecorder.addTouches(c, r);
      var n = Date.now();
      50 < n - this.previousProgressTimeStamp && (this.sdk.getProgress().evaluateTouchData(this.touchRecorder.data(), this.codeSetTypes, this.sdk.expectedCodeType, this.sdk.expectedSwipingGesture), this.previousProgressTimeStamp = n), this.prismaKeyDetection && this.prismaKeyDetection.checkKeyCode(o.pageX, o.pageY, c);
    }
  }, e.prototype.processTouchMove = function (e) {
    for (var t = 0, s = e.changedTouches; t < s.length; t++) {
      var i = s[t],
          o = i.identifier,
          r = this.touchRecorder.getById(o);

      if (r) {
        r.push(new TouchRecord_1.TouchRecord("move", o, i.radiusX, i.pageX, i.pageY));
        var c = Date.now();
        50 < c - this.previousProgressTimeStamp && (this.sdk.getProgress().evaluateTouchData(this.touchRecorder.data(), this.codeSetTypes, this.sdk.expectedCodeType, this.sdk.expectedSwipingGesture), this.sdk.getUsability().evaluateTouchData(this.touchRecorder.data(), this.sdk.expectedCodeType), this.previousProgressTimeStamp = c);
      }
    }

    this.prismaKeyDetection && this.prismaKeyDetection.checkTouchMove(this.touchRecorder.data()), this.checkSendData("move");
  }, e.prototype.processTouchEnd = function (e) {
    var t = e.changedTouches;
    this.activeTouches -= t.length, this.sdk.getInteraction().changed(this.activeTouches);

    for (var s = 0, i = t; s < i.length; s++) {
      var o = i[s],
          r = o.identifier,
          c = this.touchRecorder.getById(r);
      c && (c.push(new TouchRecord_1.TouchRecord("end", r, o.radiusX, o.pageX, o.pageY)), this.sdk.getProgress().evaluateTouchData(this.touchRecorder.data(), this.codeSetTypes, this.sdk.expectedCodeType, this.sdk.expectedSwipingGesture), this.previousProgressTimeStamp = Date.now());
    }

    this.checkSendData("end"), this.activeTouches < 1 && (this.reset(), this.sdk.getInteraction().complete());
  }, e.prototype.processTouchCancel = function (e) {
    this.activeTouches = 0, this.checkSendData("cancel"), this.reset(), this.sdk.getInteraction().complete();
  }, e.prototype.pause = function () {
    this.paused = !0, this.prismaKeyDetection && this.prismaKeyDetection.pause();
  }, e.prototype.resume = function () {
    this.paused = !1, this.prismaKeyDetection && this.prismaKeyDetection.resume();
  }, e.prototype.fetch = function (s, i) {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, this.sdk.getDataManager().fetch(this.url, s)];

          case 1:
            return t = e.sent(), this.activeRequestCount--, i >= this.successCallbackXhrNum && this.processResponse(t.status, t.data), [2];
        }
      });
    });
  }, e.prototype.isStrictMode = function () {
    var e = this.sdk.getInitialisation().initialisationResponse.clientConfig;
    return e && e.requestStrategy && "strict" === e.requestStrategy;
  }, e.prototype.isOnProgressCompleteMode = function () {
    var e = this.sdk.getInitialisation().initialisationResponse,
        t = e ? e.clientConfig : void 0;
    return t && t.requestStrategy && "onprogresscomplete" === t.requestStrategy;
  }, e.prototype.checkSendData = function (e) {
    if (!this.paused) {
      var t = 99 < this.sdk.getProgress().lastProgress || 80 <= this.sdk.getProgress().lastProgress && this.sdk.getInitialisation().initialisationResponse.ppi < 1;
      "move" !== e ? this.isStrictMode() ? 0 === this.activeTouches && t && this.sendData() : this.isOnProgressCompleteMode() ? t && this.sendData() : this.sendData() : !this.decodeRequestSent && t && this.isOnProgressCompleteMode() && (this.sendData(), this.decodeRequestSent = !0);
    }
  }, e.prototype.sendData = function () {
    if (this.isStrictMode() && this.pause(), this.isTornadoCodeType()) {
      var e = new Date().getTime();
      if (this.touchRecorder.size() < 2 || this.successCallbackSent || e - this.lastRequestTime < 500) return;
      this.lastRequestTime = e;
    } else if (this.touchRecorder.size() < 2 || this.successCallbackSent) return;

    var t = this.export(),
        s = navigator.userAgent,
        i = {
      body: t,
      headers: {
        "Content-Encoding": this.gzipUsed ? "gzip" : "identity",
        "Content-Type": "application/json",
        "user-agent": "" + s,
        "x-api-key": "" + this.sdk.getAPIKey()
      },
      method: "post"
    },
        o = this.xhrRequestNum;
    this.activeRequestCount++, this.fetch(i, o), this.xhrRequestNum++;
  }, e.prototype.processResponse = function (e, t) {
    switch (e) {
      case 200:
        this.processSuccess(t);
        break;

      default:
        this.processError(t);
    }
  }, e.prototype.processSuccess = function (e) {
    var t = new DecoderResponseSuccess_1.DecoderResponseSuccess(e);
    this.successCallbackSent || (this.successCallbackXhrNum = this.xhrRequestNum, this.successCallbackSent = !0, this.success(t));
  }, e.prototype.processError = function (e) {
    var t = this,
        s = new DecoderResponseError_1.DecoderResponseError(e, this.strings);
    "invalid_signature" === s.errorCode && (this.sdk.getInitialisation().initialisationResponse.sessionToken = s.sessionToken, this.sendData());
    var i = this.twoFingerHoldingMode ? 3 : 2;
    (0 === this.activeRequestCount && this.activeTouches < i || this.isOnProgressCompleteMode()) && setTimeout(function () {
      (0 === t.activeRequestCount && t.activeTouches < i || t.isOnProgressCompleteMode()) && (t.errorCallbackSent || (t.errorCallbackSent = !0, t.error(s)));
    }, 100);
  }, e.prototype.isTornadoCodeType = function () {
    return this.sdk.expectedCodeType ? this.sdk.expectedCodeType === CodeType_1.CodeType.Tornado : !!this.codeSetTypes.length && this.codeSetTypes[0] === CodeType_1.CodeType.Tornado;
  }, e.prototype.export = function () {
    var i = new Array();
    this.touchRecorder.data().forEach(function (e, t, s) {
      e.forEach(function (e) {
        i.push(e);
      });
    });
    var e = new DataBuilder_1.DataBuilder(this.sdk).enableCheckSumAndSignature().setCustomPayload(this.customPayload).setTouchData(i).buildJSONStringify();
    return this.gzipUsed = !1, 2048 < e.length && this.sdk.getDataManager().isOnline() ? (this.gzipUsed = !0, pako_1.gzip(e)) : e;
  }, e.prototype.getServerUrl = function () {
    return this.sdk.getServerUrl() + this.url;
  }, e;
}();

exports.Detection = Detection;